import "./Blog.css";
import arrow from "../Assets/For-status/Arrow.svg";
import { Link } from "react-router-dom";
export function Blog() {
  return (
    <div className="blog-container">
      <div className="blog-frame">
        <div className="cards-container">
          <div className="blog-cards-container">
            <div className="blog-card">
              <div className="background-img cr-1">
                <div className="btm-card">
                  <div className="date-comment">
                    <div className="date">
                      <div className="date-icn"></div>
                      15,Feb, 2024
                    </div>
                    <div className="comment">
                      <div className="comment-icn"></div>
                      05, Comments
                    </div>
                  </div>
                  <div className="blog-title">
                    <Link to="/digital">
                      <h2>Digital Marketing</h2>
                    </Link>
                  </div>
                  <div className="last-box">
                    <div className="more-info">
                      <Link to="/digital">Get more info</Link>
                    </div>
                    <div className="arrow arrow-1">
                      <Link to="/digital">
                        <img src={arrow} alt="" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="blog-card">
              <div className="background-img cr-2">
                <div className="btm-card">
                  <div className="date-comment">
                    <div className="date">
                      <div className="date-icn"></div>
                      26,Aug, 2025
                    </div>
                    <div className="comment">
                      <div className="comment-icn"></div>
                      05 Comments
                    </div>
                  </div>
                  <div className="blog-title">
                    <Link to="/blog2">
                      <h2>
                        Build a Brand That Actually Sticks in a Crowded Market
                      </h2>
                    </Link>
                  </div>
                  <div className="last-box">
                    <div className="more-info">
                      <Link to="/blog2">Get more info</Link>
                    </div>
                    <div className="arrow arrow-1">
                      <Link to="/blog2">
                        <img src={arrow} alt="" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="blog-card">
              <div className="background-img cr-3">
                <div className="btm-card">
                  <div className="date-comment">
                    <div className="date">
                      <div className="date-icn"></div>
                      14,July, 2025
                    </div>
                    <div className="comment">
                      <div className="comment-icn"></div>
                      09 Comments
                    </div>
                  </div>
                  <div className="blog-title">
                    <Link to="/blog3">
                      <h2>How Hussme help </h2>
                    </Link>
                  </div>
                  <div className="last-box">
                    <div className="more-info">
                      <Link to="/blog3">Get more info</Link>
                    </div>
                    <div className="arrow arrow-1">
                      <Link to="/blog3">
                        <img src={arrow} alt="" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="blog-card">
              <div className="background-img cr-4">
                <div className="btm-card">
                  <div className="date-comment">
                    <div className="date">
                      <div className="date-icn"></div>
                      18,Mar, 2024
                    </div>
                    <div className="comment">
                      <div className="comment-icn"></div>
                      05 Comments
                    </div>
                  </div>
                  <div className="blog-title">
                    <Link to="/blog4">
                      <h2>
                        Low-Budget Digital Marketing Strategies That Actually
                        Work
                      </h2>
                    </Link>
                  </div>
                  <div className="last-box">
                    <div className="more-info">
                      <Link to="/blog4">Get more info</Link>
                    </div>
                    <div className="arrow arrow-1">
                      <Link to="/blog4">
                        <img src={arrow} alt="" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
